<!-- <div class="container">
<full-calendar
  defaultView="dayGridMonth"
  [plugins]="calendarPlugins"
  [weekends]="false"
  [events]="[
    { title: 'event 1', date: '2019-04-01' },
    { title: 'event 2', date: '2019-04-02' }
  ]"
></full-calendar>
</div> -->
<div class="title">
  <div class="container">
      <div class="row">
          <div class="col">
              <ul class="list-inline">
                <li class="list-inline-item"><h6 class="Category">Booking</h6></li>
                <li class="list-inline-item"><i class="fas fa-angle-right"></i></li>
                <li class="list-inline-item"><h6 class="active-page">Calender</h6></li>
              </ul>
          </div>
          <div class="col">
            <a href="#" class="float-right" style="color:#28346F;font-weight:bold">
            <ul class="list-inline">
              <li class="list-inline-item"><img class="img-fluid" src="assets/images/plus.png"></li>
              <li class="list-inline-item">Add New</li>
            </ul>
          </a>
        </div>      
      </div>
    </div>
</div>
  

<div class="container pb-4">
   <div id="calendar"></div>
</div>

